import { Grid } from 'antd';
import React from 'react';
import { useTheme } from 'styled-components';

import { TRentProduct, useBasketActions, useActionsProducts } from '@/entities/product';

import { DeleteIcon, HeartIcon } from '@/shared/ui/icons';

const { useBreakpoint } = Grid;

type TProps = {
    productItem: TRentProduct;
};

export const BasketItemActionBarMini: React.FC<TProps> = ({ productItem }) => {
    const theme = useTheme();

    const screen = useBreakpoint();

    const { handleAddProductToFavorite, favoriteProducts } = useActionsProducts({ product: productItem });

    const { handleAddProductToBasket } = useBasketActions({ product: productItem });

    const isFavorite = favoriteProducts?.includes(productItem.id);

    const handleAddFavoriteProduct = () => {
        handleAddProductToFavorite();
    };

    const handleAddBasketProduct = () => {
        handleAddProductToBasket();
    };

    if (screen.md) {
        return <></>;
    }

    return (
        <div className="action-bar">
            <div>
                <div className="btn" onClick={handleAddFavoriteProduct}>
                    <HeartIcon color={theme.color.primary} filled={isFavorite} />
                </div>
            </div>
            <div>
                <div className="btn" onClick={handleAddBasketProduct}>
                    <DeleteIcon width={20} height={25} color={theme.color.neutral300} />
                </div>
            </div>
        </div>
    );
};
